import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import swal from "../../utils/swal";
import { ArrowLeft, KeyRound } from "lucide-react";
import { AUTH } from "../../config/constants";
import { Post } from "../../config/api/post";
import "../teachers/teachers.css";
import "./profile.css";

export default function ChangePass() {
  const navigate = useNavigate();
  const token = useSelector((state) => state.user.userToken);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirmPassword: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    if (form.new_password.length < 8) {
      swal("Invalid password", "New password must be at least 8 characters.", "error");
      return;
    }

    if (form.new_password !== form.confirmPassword) {
      swal("Passwords do not match", "New password and confirmation must match.", "error");
      return;
    }

    setSaving(true);
    Post(
      AUTH.changePassword,
      {
        old_password: form.old_password,
        new_password: form.new_password,
      },
      token
    )
      .then((response) => {
        const body = response?.data;
        if (body?.status) {
          swal("Success!", body.message || "Password updated successfully", "success");
          navigate("/profile");
        } else {
          swal("Oops!", body?.message || response?.response?.data?.message || "Update failed", "error");
        }
      })
      .catch((error) => {
        swal("Oops!", error?.data?.message || "Something went wrong", "error");
      })
      .finally(() => setSaving(false));
  };

  return (
    <div className="profile-page">
      <button type="button" className="profile-back-btn" onClick={() => navigate("/profile")}>
        <ArrowLeft size={16} />
        Back to profile
      </button>

      <div className="profile-card">
        <div className="profile-card-head">
          <div>
            <h2>Change password</h2>
            <p className="profile-card-sub">Update your admin account password</p>
          </div>
          <KeyRound size={20} style={{ color: "var(--bw-text-muted)" }} />
        </div>

        <form className="profile-card-body profile-pass-form" onSubmit={handleSubmit}>
          <div className="profile-field">
            <label htmlFor="old-password">Current password</label>
            <input
              id="old-password"
              type="password"
              autoComplete="current-password"
              value={form.old_password}
              onChange={(event) => setForm((prev) => ({ ...prev, old_password: event.target.value }))}
              required
            />
          </div>

          <div className="profile-field">
            <label htmlFor="new-password">New password</label>
            <input
              id="new-password"
              type="password"
              autoComplete="new-password"
              value={form.new_password}
              onChange={(event) => setForm((prev) => ({ ...prev, new_password: event.target.value }))}
              required
              minLength={8}
            />
          </div>

          <div className="profile-field">
            <label htmlFor="confirm-password">Confirm new password</label>
            <input
              id="confirm-password"
              type="password"
              autoComplete="new-password"
              value={form.confirmPassword}
              onChange={(event) => setForm((prev) => ({ ...prev, confirmPassword: event.target.value }))}
              required
              minLength={8}
            />
          </div>

          <div className="profile-actions">
            <button type="submit" className="data-primary" disabled={saving}>
              {saving ? "Updating..." : "Update password"}
            </button>
            <button type="button" className="data-secondary" disabled={saving} onClick={() => navigate("/profile")}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
